"use client";

/** Sets page backgrounds and scrolling behavior for the current route. */
import { usePathname } from "next/navigation";
import { cva } from "styled-system/css";

import { getBackgroundForPath } from "./(main)/background";

export function Body({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isTradePage = pathname.startsWith("/trade");
  const isAgentPage = pathname === "/agent" || pathname.startsWith("/agent/");

  const background = getBackgroundForPath(pathname);

  return (
    <body
      className={bodyStyles({ trade: isTradePage })}
      data-page={isAgentPage ? "agent" : undefined}
      style={{ background: background?.children }}
    >
      {children}
    </body>
  );
}

const bodyStyles = cva({
  base: {
    display: "flex",
    flexDirection: "column",
    minH: "[100vh]",
    color: "text.secondary",
    bg: "background.canvas",
    textStyle: "body.md",
    // A (main) page's notFound() renders inside the (main) layout; drop its
    // banner strip so it matches the bare 404 for unmatched URLs.
    "&:has([data-not-found]) [data-app-banners]": { display: "none" },
    desktop: {
      "&[data-page='agent']": {
        height: "[100dvh]",
        minHeight: "[100dvh]",
        overflow: "hidden",
        "& [data-app-header], & [data-app-banners]": { flexShrink: "0" },
        "& [data-app-content]": { minHeight: "0", overflow: "hidden" },
      },
    },
  },
  variants: {
    trade: {
      true: { bg: "background.primary", desktop: { bg: "background.canvas" } },
    },
  },
});
